import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import type { SSHKeyResponseModel } from '@xver/apis/v1/ssh-keys/model';

export const SSH_KEYS_QUERY_KEY = ['apis.v1.ssh-keys'];

export function useSSHKeysQuery() {
    return useQuery<SSHKeyResponseModel[]>({
        queryKey: SSH_KEYS_QUERY_KEY,
        queryFn: Endpoints.v1.SSHKeys.getSSHKeys,
    });
}
